export const FILE_NAME_DATE_FORMAT = 'YYYY-MM-DD';
export const ACTIVITY_FEED_FILE_NAME = '_Activity_feed_';
export const ENGAGEMENT_FILE_NAME = '_Group_risk_assessment_';
export const clientRequestHeadersActivityFeed = {
	sourceEngagement: 'sourceEngagement',
	engagementDescription: 'engagementDescription',
	activityType: 'activityType',
	objectImpacted: 'objectImpacted',
	relatedObjectImpacted: 'relatedObjectImpacted',
	relatedSecondaryObjectImpacted: 'relatedSecondaryObjectImpacted',
	activityDate: 'activityDate'
};

export const clientRequestHeadersEngagement = {
	engagementDescription: 'engagementDescription',
	canvasEngagementId: 'canvasEngagementId',
	accountName: 'accountName',
	pspIndexTitle: 'pspIndexTitle',
	accountTypeName: 'accountTypeName',
	assertionName: 'assertionName',
	inherentRiskTypeName: 'inherentRiskTypeName',
	controlRiskTypeName: 'controlRiskTypeName',
	controlRiskAssessment: 'controlRiskAssessment',
	riskTypeName: 'riskTypeName',
	riskName: 'riskName',
	taskStatus: 'taskStatus',
	relatedTasks: 'relatedTasks'
};

export const exportOptions = {
	activityFeed: 1,
	engagementData: 2
};
